
const local_deploy_boilerplate = (template_doc,template_id,document_id) => {
    let DOM_element = template_doc.getElementById(template_id);
    let DOM_element_stub = document.getElementById(document_id);
    
    if( DOM_element == null) return;
    if( DOM_element_stub == null) return;

    DOM_element_stub.replaceWith(DOM_element.content);
    DOM_element_stub.dispatchEvent(new Event("boilerplatedeployed"));
}

const local_deploy_subpage_item = (template_doc,template_id,item_container_id) => {
    const DOM_item_container = document.getElementById(item_container_id);
    const DOM_item = template_doc.getElementById(template_id);

    if(DOM_item_container){
        var clone = DOM_item.content.cloneNode(true);
        DOM_item_container.appendChild(clone);
    } else {
        console.log(`boilerplate:[Warning] container_id '${item_container_id}' not found.`);
    }
}

export const deploy_boilerplate = (template_doc) =>{

        // 関数の特殊化
        let deploy_boilerplate = local_deploy_boilerplate.bind(null,template_doc);
        let deploy_subpage_item = local_deploy_subpage_item.bind(null,template_doc);

        // ナビゲーションメニュー/フッター用メニュー項目テンプレート名のリスト
        let ary_name_navbar_item = {
            '/concorso/manifesto.html':'navbar_manifesto_item_boilerplate',
            'default':'navbar_item_boilerplate'
        };
        let name_navbar_item;
        let with_custom_navbar_item=false;

        // ボイラープレート展開処理の呼び出し。
        // ボイラープレートを追加した場合はここに展開処理を追加する必要がある。

        deploy_boilerplate("navbar_boilerplate","navbar");
        deploy_boilerplate("footer_boilerplate","footer");
    
        if(js_cookie.get('current_user_token') === void(0)){
            deploy_boilerplate("login_swiper_boilerplate","login_swiper");
        }

        // ナビゲーションメニュー/フッター用メニュー項目の展開

        with_custom_navbar_item = window.location.pathname in ary_name_navbar_item;
        name_navbar_item = (with_custom_navbar_item)? ary_name_navbar_item[window.location.pathname]:ary_name_navbar_item['default'];

        deploy_subpage_item(name_navbar_item,"navbar-item");
        deploy_subpage_item(name_navbar_item,"subpage_item");
        
        window.dispatchEvent(new Event("boilerplatedeployed"));
};

